<template>
  <div
    class="sm:px-1 my-4 flex flex-wrap items-center gap-x-4 md:gap-x-6 gap-y-4 w-full min-h-[48px]">
    <div
      class="w-full sm:w-auto flex justify-between sm:justify-normal items-center gap-x-4">
      <div class="w-24 h-6 rounded-full bg-gray-700 animate-pulse"></div>
    </div>
    <div
      class="ml-auto min-w-[195px] flex items-center justify-center w-full h-12 sm:justify-normal sm:w-auto gap-2 text-neutral-300 border-gray-700 rounded-sm p-2 cursor-default"
      data-test="button-toggle-filters-drawer">
      <div class="h-6 w-full rounded-full bg-gray-700 mx-2 animate-pulse"></div>
    </div>
  </div>
</template>
